import { dispatch } from "d3";
import { useSelector, useDispatch } from "react-redux";
import {addLendBooks, addBookReturns, getBooksList, getBooksTitle, getStudentId, resetBookReturnList} from "../store/lend";

function useLend() {
    const dispatch =useDispatch();
    const check = useSelector((state)=> state.lend); 

const bookList = useSelector((state) => state.lend.bookReturnList);   
const studentList = useSelector((state)=> state.lend.studentList);
const bookTitle = useSelector((state)=> state.lend.bookTitle);
const loading = useSelector((state)=> state.lend.loading);


const addLendBooksInfo = (params) => dispatch(addLendBooks(params));
const getStudentInfo = (params) => dispatch(getStudentId(params))
const addBookReturnsInfo = (params) => dispatch(addBookReturns(params));
const getBooksListInfo = (params) => dispatch(getBooksList(params));
const getBooksTitleInfo = (params) => dispatch(getBooksTitle(params));
const resetBookReturnListAction = (params) => dispatch(resetBookReturnList(params));


return {
    //actions//
    addLendBooksInfo,
    addBookReturnsInfo,
    getBooksListInfo,
    getBooksTitleInfo,
    getStudentInfo,
    resetBookReturnListAction,
    //States//
    loading,
    getBooksList,
    addLendBooks,
    addBookReturns,
    bookList,
    studentList,
    bookTitle,
}
}
export default useLend; 